// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"f81bbcd3","234":"c476e6a4","276":"aea8d786","359":"ea8ab0db","361":"11d1b3c6","365":"8b11f9b8","748":"dfb9def0"}[chunkId] + ".chunk.js";
};